import { z } from 'zod';

/** UI host selects provider-scoped tools; it never changes the authenticated user. */
export const CASE_DISCOVERY_SURFACES = ['web', 'outlook', 'gmail'] as const;
export const CaseDiscoverySurfaceSchema = z.enum(CASE_DISCOVERY_SURFACES);
export type CaseDiscoverySurface = z.infer<typeof CaseDiscoverySurfaceSchema>;
